import { BlurbLogoIcon } from '../icons/icon-def/BlurbLogoIcon';
import { useTranslation } from '@rpi/i18n';

const CheckoutHeader = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.projects' });
  return (
    <>
      <div className="items-start mb-6 mt-6 md:mt-4 md:mb-2 md:mx-36 ">
        <a
          className="m-4"
          rel="noopener noreferrer"
          href={'/user/cart'}
          aria-label={t('cart_label') || 'Cart icon'}
        >
          <span className="material-symbols-outlined text-gray-dark">
            shopping_cart
          </span>
        </a>
      </div>
      <div className="flex justify-center md:order-first">
        <div className="md:w-[53px] w-[40px] mb-4 md:mt-5 md:mb-2">
          <BlurbLogoIcon />
        </div>
      </div>
    </>
  );
};

export default CheckoutHeader;
